import DateFnsUtils from "@date-io/date-fns";
export default class ProLogsDateFnsUtils extends DateFnsUtils {
  setHours(value: Date, count: number): Date {
    let retVal = super.setHours(value, count);
    if (retVal.getHours() !== count && count < 12) {
      console.log(
        `Encountered a possible DST boundary, assuming the user selected '${
          count + 12
        }' hours instead of '${count}'`
      );
      retVal = super.setHours(value, count + 12);
    }

    return retVal;
  }
}
